import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { ClientFilter } from 'src/app/model/client-filter';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { ClientService } from 'src/app/services/client.service';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { BillingInvoiceManualService } from '../../../services/billing/billing-invoice-manual/billing-invoice-manual.service';

@Component({
  selector: 'app-billing-invoice-manual-filter',
  templateUrl: './billing-invoice-manual-filter.component.html',
  styleUrls: ['./billing-invoice-manual-filter.component.css']
})
export class BillingInvoiceManualFilterComponent implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;
  filterCompleteClients: FilterCompleteService<ClientFilter>;

  constructor( private formBuilder: FormBuilder,
               private notificationToastService: NotificationToastService,
               private clientService: ClientService,
               private billingInvoiceManualService: BillingInvoiceManualService,
               private filterRecordService: FilterRecordService ) {

    this.form = this.formBuilder.group({
      invoiceNumber: [ '' ],
      client: [ null ],
      clientCode: [ '' ],
      from: [ '' ],
      to: [ '' ]
    });

    this.filterCompleteClients = new FilterCompleteService<ClientFilter>([], this.form.controls.client);
  }

  get f() { return this.form.controls; }
  get filteredClientsOptions() { return this.filterCompleteClients ? this.filterCompleteClients.filteredOptions : []; }

  ngOnInit() {
    this.clientService.getClientFilters().then((info) => {
      this.filterCompleteClients = new FilterCompleteService<ClientFilter>(info,
        this.form.controls.client);
    });
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('BillingInvoiceManualFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('BillingInvoiceManualFilterComponent', this.form);
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async search(): Promise<any> {
    if ( !this.existsFilter() ) {
      this.notificationToastService.error('Debe seleccionar al menos un filtro', 'Generar nota de crédito');
      return [];
    } else {
      const items =  await this.billingInvoiceManualService.getBillingInvoiceManualSearchItems(
        (this.form.controls.clientCode.value ? this.form.controls.clientCode.value : ''),
        (this.form.controls.invoiceNumber.value ? this.form.controls.invoiceNumber.value : null),
        (this.form.controls.from.value ? <Date>this.form.controls.from.value : null),
        (this.form.controls.to.value ? <Date>this.form.controls.to.value : null),
        (this.form.controls.client.value ? this.form.controls.client.value.Id : null));
      return items;
    }
  }

  existsFilter(): boolean {

    return  this.form.controls.clientCode.value ||
            this.form.controls.invoiceNumber.value ||
            this.form.controls.client.value ||
            this.form.controls.from.value ||
            this.form.controls.to.value;
  }
}
